module.exports = __webpack_public_path__ + "img/online-pay.8929688b.png";